function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutubeIcon = function SvgYoutubeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u5716\\u5C64 1",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm4.44 16.89a87.67 87.67 0 0 1-8.88 0C5.28 16.74 5 15.62 5 12s.28-4.74 2.56-4.89a87.67 87.67 0 0 1 8.88 0C18.72 7.26 19 8.38 19 12s-.28 4.74-2.56 4.89ZM10 9.66 14.92 12 10 14.34Z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgYoutubeIcon;